"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.subjectFieldSchema = void 0;
const zod_1 = require("zod");
const constants_1 = require("../constants");
exports.subjectFieldSchema = zod_1.z.string().min(1).max(constants_1.SUBJECT_MAX_LENGTH);
//# sourceMappingURL=subjectField.schema.js.map